export default __webpack_public_path__ + "static/media/launchpad.cdd1c9c5.svg";